exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-532c5ea9]{margin:40px 0 0}ul[data-v-532c5ea9]{list-style-type:none;padding:0}li[data-v-532c5ea9]{display:inline-block;margin:0 10px}a[data-v-532c5ea9]{color:#42b983}.inline[data-v-532c5ea9]{display:inline}.aside[data-v-532c5ea9]{padding:30px;border:2px solid #00f;width:20%;position:absolute}.item-list[data-v-532c5ea9]{top:-20%;display:inline-flex}.content-container[data-v-532c5ea9]{position:\"relative\"}.notification[data-v-532c5ea9]{background-color:transparent;color:#4c77b6;font-size:24px;font-weight:700;text-align:center;margin:0;width:100%}.is-one-fifth[data-v-532c5ea9]{min-width:240px;max-width:300px}", ""]);

// exports
